import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { JwtHelper } from "angular2-jwt/angular2-jwt";
import decode from "jwt-decode";
import { environment } from "../../../environments/environment";
import { Role } from "../models/role";
import { UserProfile } from "../models/user-profile";

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    public router: Router,
    private jwtHelper: JwtHelper,
    private http: HttpClient,
    @Inject("API_LOGIN") private loginUrl: string
  ) {}

  canActivate(): boolean {
    if (!this.isAuthenticated()) {
      // this.router.navigate(["login"]);
      window.location.href = this.loginUrl;
      return false;
    }
    return true;
  }

  hasRole(roleName: string): boolean {
    const token = localStorage.getItem("access_token");
    const tokenPayload = decode(token);
    let roles: string[] = tokenPayload.authorities;

    //return this.isAuthenticated() && roles.includes(roleName);
    return roles.includes(roleName);
  }

  public saveToken(data) {
    localStorage.setItem("access_token", data["access_token"]);
    localStorage.setItem("expires_in", data["expires_in"]);
    localStorage.setItem("jti", data["jti"]);
    localStorage.setItem("refresh_token", data["refresh_token"]);
    localStorage.setItem("scope", data["scope"]);
    localStorage.setItem("token_type", data["token_type"]);
  }

  public clearToken() {
    localStorage.setItem("access_token", "");
    localStorage.setItem("expires_in", "");
    localStorage.setItem("jti", "");
    localStorage.setItem("refresh_token", "");
    localStorage.setItem("scope", "");
    localStorage.setItem("token_type", "");
  }

  public getAccessToken(): string {
    return localStorage.getItem("access_token");
  }
  public getRefreshToken(): string {
    return localStorage.getItem("refresh_token");
  }

  public isAuthenticated(): boolean {
    const token = localStorage.getItem("access_token");
    // Check whether the token is expired and return
    // true or false
    try {
      return !this.jwtHelper.isTokenExpired(token);
    } catch (error) {
      console.log("error: ", error);
      return false;
    }
  }
  public isExpired(): boolean {
    const token = localStorage.getItem("access_token");
    // Check whether the token is expired and return
    // true or false
    return this.jwtHelper.isTokenExpired(token);
  }

  public saveUserProfileInformation(userProfileJson: string) {
    localStorage.setItem("userProfile", userProfileJson);
  }

  public getUserProfileInformation(): UserProfile {
    return JSON.parse(localStorage.getItem("userProfile")) as UserProfile;
  }

  public isDcaInternal(): boolean {
    return this.hasRole(Role.DCA_IN);
  }
  public isDcaMember(): boolean {
    return this.hasRole(Role.DCA_MEMBER);
  }

  public doRefreshToken() {
    let grantType = "refresh_token";
    let refresh_token = this.getRefreshToken();
    let body = `grant_type=${grantType}&refresh_token=${refresh_token}`;

    let clientCredentials = "trusted-app:secret";
    let options = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", `Basic ${btoa(clientCredentials)}`),
    };

    return this.http.post(environment.backUrl + "oauth/token", body, options);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/auth-guard.service.ts